import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

export const CommonTnc2 = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Trans i18nKey="life.MakeRequestcontact.agreetext" style={{ marginLeft: '20px', fontSize: '17px' }}>
      {t('life.MakeRequest.contact.agreetext')}
    </Trans>
  );
};
